import { ref, watch } from 'vue'
import type { Ref } from 'vue'
export function useProjectTableFilter(tableData: Ref<Array<any>>, searchArr: Array<any>) {
  // const allData = ref(JSON.parse(JSON.stringify(tableData)));
  const allData = tableData.value

  const filtered = ref(tableData.value)
  const search = ref(searchArr)
 //  console.log("project table filter: tableData = " + JSON.stringify(tableData.value));
 // console.log("project table filter: allData.length = " + allData.length);
 //  console.log("project table filter: filtered.length = " + filtered.value.length);
  //this is failing on customer field, as some of them are null
  watch(
    () => search.value,
    (newVal, oldVal) => {
      //console.log("watch called on searchArr.value = " + JSON.stringify(newVal));
      //let lowercase = newVal.map(text=>{
      //  return text.toString().toLowerCase();
      //});
      filtered.value = allData.filter((row) => {
        //console.log("..row = " + JSON.stringify(row));
        const projId = newVal['id'].toString().toLowerCase()
        const address = newVal['streetAddress'].toString().toLowerCase()
        const city = newVal['city'].toString().toLowerCase()
        const prov = newVal['province'].toString().toLowerCase()
        const customer = newVal['customer'].toString().toLowerCase()
        //const searchStatus = newVal['status'].toString().toUpperCase();
        const searchStatus = newVal['status']
        const rowCust = row.customer // || ''; //object
        const engineer = newVal['engineer'].toString().toLowerCase();
        const drafter = newVal['drafter'].toString().toLowerCase();
        const owner = newVal['owner'].toString().toLowerCase();
       // const source = newVal['source'].toString().toLowerCase();
        const division = newVal['division'].toString().toLowerCase();

        const statusEmpty = (searchStatus.length===0 ) ? true : false;
        if(!statusEmpty){
          //console.log('statusArr = ' + statusArr)
        }else{
         // console.log('statusArr is empty');
        }
          const statusIncluded =
            searchStatus.every((el) => {
                return row['status'].includes(el);
            })
        
        //console.log("statusIncluede= " + statusIncluded);

        return (
          row['id'].toString().toLowerCase().includes(projId) &&
          row['streetAddress'].toString().toLowerCase().includes(address) &&
          row['city'].toString().toLowerCase().includes(city) &&
          row['province'].toString().toLowerCase().includes(prov) &&
          (row['engineer']==null ? true : row['engineer'].toString().toLowerCase().includes(engineer)) &&
          (row['owner']==null ? true : row['owner'].toString().toLowerCase().includes(owner)) &&
          (row['drafter']==null ? true : row['drafter'].toString().toLowerCase().includes(drafter)) &&
          row['customer'].toString().toLowerCase().includes(customer) &&
        //  row['source'].toString().toLowerCase().includes(source) &&
          row['division'].toString().toLowerCase().includes(division) &&
         // rowCust.name.toString().toLowerCase().includes(customer) &&
          (statusIncluded)// || statusEmpty)
        )
      })
      //filtered.value = props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(newVal.toLowerCase()));
    },
    { deep: true }
  )

  return { filtered }
}
